import React, { memo } from 'react'
import ReactPaginate from 'react-paginate';
import styled from 'styled-components'
const Pagination = memo(({ onChange, pageCount = 8, pageRange = 3, currentPage, style, previousLabel = "&laquo;", nextLabel = "&raquo;" }) => {
    return (
        <MyPaginate style={style}>
            <ReactPaginate
                breakLabel="..."
                nextLabel={nextLabel}
                onPageChange={onChange}
                pageRangeDisplayed={pageRange}
                pageCount={pageCount}
                previousLabel={previousLabel}
                renderOnZeroPageCount={null}
                forcePage={currentPage != null ? currentPage : undefined}
            />
        </MyPaginate>
    )
})

export default Pagination


const MyPaginate = styled.div`
ul{
    display: flex;
    background-color: white;
    align-items: center;
    box-shadow: 0 1px 3px rgba(0,0,0,0.08);
    border-radius: 8px;
    border: 1px solid #E5E7EB;
    width: fit-content;
    padding: 0;
    margin: 0;
    overflow: hidden;
    li.selected{
        background-color: var(--paginate-selected-bg, #0D6EFD);
        color: var(--paginate-selected-color, #ffffff);
    }
    li.selected a {
        color: var(--paginate-selected-color, #ffffff);
    }
    li{
        padding:8px 14px;
        list-style: none;
        border-right: 1px solid #E5E7EB ;
        color: #000000;
    }
    li:last-child{
        border-right: none;
    }
    a{
        text-decoration: none;
        color: inherit;
    }
}
`